
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire3a11"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire3a11"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("hS6sa", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $d02c7c5283a16a22$export$6503ec6e8aabbaf; }, function (v) { return $d02c7c5283a16a22$export$6503ec6e8aabbaf = v; });
var $d02c7c5283a16a22$export$6503ec6e8aabbaf;
var $d02c7c5283a16a22$export$f7ad0328861e2f03;
"use strict";
var $d02c7c5283a16a22$var$mapping = new Map();
function $d02c7c5283a16a22$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$d02c7c5283a16a22$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $d02c7c5283a16a22$var$resolve(id) {
    var resolved = $d02c7c5283a16a22$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$d02c7c5283a16a22$export$6503ec6e8aabbaf = $d02c7c5283a16a22$var$register;
$d02c7c5283a16a22$export$f7ad0328861e2f03 = $d02c7c5283a16a22$var$resolve;

});

parcelRegister("iKXx1", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $da7ab3960c3950b9$export$bdfd709ae4826697; }, function (v) { return $da7ab3960c3950b9$export$bdfd709ae4826697 = v; });
var $da7ab3960c3950b9$export$bdfd709ae4826697;
var $da7ab3960c3950b9$export$c9e73fbda7da57b6;
var $da7ab3960c3950b9$export$5a759dc7a1cfb72a;
"use strict";
var $da7ab3960c3950b9$var$bundleURL = {};
function $da7ab3960c3950b9$var$getBundleURLCached(id) {
    var value = $da7ab3960c3950b9$var$bundleURL[id];
    if (!value) {
        value = $da7ab3960c3950b9$var$getBundleURL();
        $da7ab3960c3950b9$var$bundleURL[id] = value;
    }
    return value;
}
function $da7ab3960c3950b9$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $da7ab3960c3950b9$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $da7ab3960c3950b9$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $da7ab3960c3950b9$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$da7ab3960c3950b9$export$bdfd709ae4826697 = $da7ab3960c3950b9$var$getBundleURLCached;
$da7ab3960c3950b9$export$c9e73fbda7da57b6 = $da7ab3960c3950b9$var$getBaseURL;
$da7ab3960c3950b9$export$5a759dc7a1cfb72a = $da7ab3960c3950b9$var$getOrigin;

});

var $1386ae5a862a6ba0$exports = {};


(parcelRequire("hS6sa")).register((parcelRequire("iKXx1")).getBundleURL("cXOp1"), JSON.parse('["cXOp1","index.2dd97d51.js","j55cI","icons.c14567a0.svg"]'));


//# sourceMappingURL=index.runtime.fc874a40.js.map
